import React, { useEffect } from 'react';
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import addNewBookToServer from '../../redux/book/thunk/addBook';
import updateSingleBook from '../../redux/book/thunk/updateSIngleBook';

const BookForm = () => {
    const { register, handleSubmit, watch, setValue, formState: { errors }, reset } = useForm();
    const dispatch = useDispatch();
    const { selectForUpdate } = useSelector(state => state.books)


    useEffect(() => {
        if (selectForUpdate.id) {
            Object.keys(selectForUpdate).forEach(singleKey => {
                setValue(singleKey, selectForUpdate[singleKey])
            })
        }
    }, [selectForUpdate, setValue])

    const onSubmit = data => {
        data.price = parseFloat(data.price)
        data.rating = parseInt(data.rating)
        if (selectForUpdate.id) {
            dispatch(updateSingleBook({ ...data, id: selectForUpdate.id }))
        } else {
            dispatch(addNewBookToServer(data))

        }
        reset()
    }

    return (
        <div className="p-4 overflow-hidden bg-white shadow-cardShadow rounded-md">
            <h4 className="mb-8 text-xl font-bold text-center">{
                selectForUpdate.id ? "Update Book" : 'Add New Book'
            }</h4>
            <form onSubmit={handleSubmit(onSubmit)} className="book-form">
                <div className="space-y-2">
                    <label for="name">Book Name</label>
                    <input required className="text-input" type="text" id="input-Bookname" name="name" {...register("name", { required: true })} />
                </div>

                <div className="space-y-2">
                    <label for="category">Author</label>
                    <input required className="text-input" type="text" id="input-Bookauthor" name="author" {...register("author", { required: true })} />
                </div>

                <div className="space-y-2">
                    <label for="image">Image Url</label>
                    <input required className="text-input" type="text" id="input-Bookthumbnail" name="thumbnail" {...register("thumbnail", { required: true })} />
                </div>

                <div className="grid grid-cols-2 gap-8 pb-4">
                    <div className="space-y-2">
                        <label for="price">Price</label>
                        <input required className="text-input" id="input-Bookprice" name="price" step='any' {...register("price", { required: true })} type="number" />
                    </div>

                    <div className="space-y-2">
                        <label for="quantity">Rating</label>
                        <input required className="text-input" type="number" id="input-Bookrating" name="rating" min="1" max="5" {...register("rating", { required: true })} />
                    </div>
                </div>

                <div className="flex items-center">
                    <input id="input-Bookfeatured" type="checkbox" name="featured" className="w-4 h-4" {...register("featured")} />
                    <label for="featured" className="ml-2 text-sm"> This is a featured book </label>
                </div>

                <button type="submit" className="submit" id="submit">{
                    selectForUpdate.id ? "Update Book" : "Add Book"
                }</button>
            </form>
        </div>
    );
};

export default BookForm;